<template>
  <div>
    <mainHeader></mainHeader>
    <div class="has-header" v-if="canSysAdminAccess || canStudyAdminAccess">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import mainHeader from "@/components/common/main-header";
import { SYSTEM_ADMIN, STUDY_ADMIN } from "@/constants/authRoles";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";

export default {
  name: "activity-library",

  components: {
    mainHeader
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    }
  }
};
</script>

<style scoped lang="scss"></style>
